import { render, staticRenderFns } from "./displayBoard.vue?vue&type=template&id=3e8585e1&scoped=true&"
import script from "./displayBoard.vue?vue&type=script&lang=js&"
export * from "./displayBoard.vue?vue&type=script&lang=js&"
import style0 from "./displayBoard.vue?vue&type=style&index=0&id=3e8585e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8585e1",
  null
  
)

export default component.exports